import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { generateLabel } from "./generateLabel";
import { ContactOrder } from "../types";
import { fMonthDayYearDotNotation } from "../../../../utils/formatTime";
import StickyTable from "../../../../shared/StickyTable";

export default function OrdersTable({ orders }: { orders: ContactOrder[] }) {
  const momentumUrl = import.meta.env.VITE_MOMENTUM_URL;
  return (
    <StickyTable size="medium">
      <TableHead>
        <TableRow>
          <TableCell width="20%">Order #</TableCell>
          <TableCell width="16%">Name</TableCell>
          <TableCell width="16%">Role in Order</TableCell>
          <TableCell width="16%">Represents</TableCell>
          <TableCell width="16%">Received Date</TableCell>
          <TableCell width="16%">Closing Date</TableCell>
          <TableCell width="16%">C/R</TableCell>
          <TableCell>Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {orders.map((o) => (
          <TableRow key={`${o.contactId}-${o.orderNumber}-${o.closingDate}-${o.orderStatus}-${o.contactType}`}>
            <TableCell>
              <a target="_blank" style={{ color: "#212B36" }} href={`${momentumUrl}new-home/${o.orderNumber}`}>
                <Typography variant="subtitle2">
                  {o.titleCompanyPrefix ? `${o.titleCompanyPrefix}-` : ""}
                  {o.orderNumber}
                </Typography>
              </a>
            </TableCell>
            <TableCell>
              <Typography variant="body2" alignItems={"center"} display="flex">
                <div style={{ width: 20 }}>{o.isMarketingSource && "⭐"}</div> {o.name}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2">{o.contactType}</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2">{o.represents}</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2">{o.receivedDate ? fMonthDayYearDotNotation(o.receivedDate) : ""}</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2">{o.closingDate ? fMonthDayYearDotNotation(o.closingDate) : ""}</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2">{o.propertyUse.charAt(0)}</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2">{generateLabel(o.orderStatus || "")}</Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </StickyTable>
  );
}
